import axios from 'axios';
import { AppConfig } from 'AppConfig';
import { CLEAN_SESSION } from 'features/masterData/util/CommonUtil';
import LocalStore from 'utils/LocalStore';

const RETRYABLE_STATUS_CODES = new Set([408, 429, 500, 502, 503, 504]);
const DEFAULT_RETRY_COUNT = 2;
const DEFAULT_RETRY_DELAY_MS = 500;
const TOKEN_EXPIRE = 'TOKEN_IS_EXPIRED';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const shouldCleanSession = (error) => {
  return error?.response?.data?.errorCode === TOKEN_EXPIRE;
};

const isRetryableFoDetailError = (error) => {
  const status = error?.response?.status;
  return !error?.response || RETRYABLE_STATUS_CODES.has(status);
};

const buildHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  Authorization: 'Bearer ' + LocalStore.getAccessToken()
});

export async function postFoDetailWithRetry(path, body = {}, options = {}) {
  const {
    retries = DEFAULT_RETRY_COUNT,
    retryDelayMs = DEFAULT_RETRY_DELAY_MS
  } = options;
  let lastError;

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const response = await axios.post(`${AppConfig.FO_INITIAL_URL}${path}`, body, {
        headers: buildHeaders(),
        hideSpinner: true
      });
      return response.data;
    } catch (error) {
      lastError = error;

      if (shouldCleanSession(error)) {
        CLEAN_SESSION();
        break;
      }

      const hasMoreRetries = attempt < retries;
      if (!hasMoreRetries || !isRetryableFoDetailError(error)) {
        break;
      }

      await sleep(retryDelayMs * (2 ** attempt));
    }
  }

  throw lastError;
}



